import { fireEvent, render, screen } from "@testing-library/react";
import BackgroundDocumentCompletion from "./BackgroundDocumentCompletion";
import { useDownloadDocument } from "../services/api";

jest.mock("../services/api", () => ({
  useDownloadDocument: jest.fn(),
}));

const mockedUseDownloadDocument = jest.mocked(useDownloadDocument);

describe("BackgroundDocumentCompletion", () => {
  const downloadDocument = jest.fn().mockResolvedValue(undefined);

  beforeEach(() => {
    jest.clearAllMocks();
    mockedUseDownloadDocument.mockReturnValue(downloadDocument);
  });

  it("shows the created title as an authenticated document download link", () => {
    render(
      <BackgroundDocumentCompletion
        workspaceId="workspace-1"
        status="completed"
        documentId="document-1"
        documentTitle="Quarterly plan.docx"
      />,
    );

    expect(screen.getByTestId("background-document-created").textContent).toBe(
      "Created: Quarterly plan.docx",
    );
    fireEvent.click(screen.getByRole("link", { name: "Quarterly plan.docx" }));
    expect(downloadDocument).toHaveBeenCalledWith(
      "workspace-1",
      "document-1",
      "Quarterly plan.docx",
    );
  });

  it.each([
    { documentId: undefined, documentTitle: "Quarterly plan.docx" },
    { documentId: "document-1", documentTitle: undefined },
  ])(
    "falls back to plain Created when document identity is incomplete",
    (props) => {
      render(
        <BackgroundDocumentCompletion
          workspaceId="workspace-1"
          status="completed"
          {...props}
        />,
      );

      expect(
        screen.getByTestId("background-document-created").textContent,
      ).toBe("Created");
      expect(screen.queryByRole("link")).toBeNull();
    },
  );

  it("keeps the card in progress until the per-job completion arrives", () => {
    const { rerender } = render(
      <BackgroundDocumentCompletion
        workspaceId="workspace-1"
        status="running"
        documentId="document-1"
        documentTitle="Quarterly plan.docx"
      />,
    );

    expect(screen.getByTestId("background-document-created").textContent).toBe(
      "Creating…",
    );
    expect(screen.queryByRole("link")).toBeNull();

    rerender(
      <BackgroundDocumentCompletion
        workspaceId="workspace-1"
        status="completed"
        documentId="document-1"
        documentTitle="Quarterly plan.docx"
      />,
    );

    expect(screen.getByTestId("background-document-created").textContent).toBe(
      "Created: Quarterly plan.docx",
    );
    expect(
      screen.getByRole("link", { name: "Quarterly plan.docx" }),
    ).toBeTruthy();
  });

  it("shows a check-back message after bounded recovery is exhausted", () => {
    render(
      <BackgroundDocumentCompletion
        workspaceId="workspace-1"
        status="running"
        recoveryMessage="Still working. Check back shortly."
      />,
    );

    expect(screen.getByTestId("background-document-created").textContent).toBe(
      "Still working. Check back shortly.",
    );
  });
});
